module.exports = __webpack_public_path__ + "img/emtecom.c522ae01.jpg";